export const GET_CURRENT_APP_INSTALLATION_QUERY = /* GraphQL */ `
    query {
        currentAppInstallation {
            id
        }
    }
`;

export interface GetCurrentAppInstallationResponse {
    currentAppInstallation: {
        id: string;
    };
}
